import { i18n } from "../src/plugins/i18n";

const content = {
  page_title: "Scavenger",
  device_details_title: ["TransformerName"],
  data_call_details: [
    {
      label: "Latest Message Time",
      value: "last_message_time_display",
      tooltip: "Last time a message was received from the device.",
      transition_on: "latest_message_timestamp",
    },
  ],
  device_details: [
    {
      label: "Transformer  No.",
      value: "TransformerNo",
    },
    {
      label: "Transformer Rating",
      value: "TransformerRating",
      suffix: "kVA",
    },
    {
      label: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
    },
    {
      label: "Device Status",
      value: "DeviceStatus",
      type: "tooltip",
      tooltip_text: "Updated on ",
      tooltip_value: "StatusDate",
      tooltip_icon: "mdi-information-variant",
    },
    {
      label: "Connection Type",
      value: "ConnectionType",
    },
    {
      label: "Monitor Type",
      value: "Type",
    },
    {
      label: "Connected MPRNs",
      value: "ConnectedMPRNs",
    },
    {
      label: "Missed Messages",
      value: [{ id: "MissedMessages" }, { id: "ExpectedMessageCount", fade: true }],
      type: "multi",
      join_with: "/",
      multi_tooltip: "% of messages missed by the device in last seven days",
    },
  ],
  devices_overview_select: [
    {
      label: "Today",
      value: "1",
    },
    {
      label: "This Week",
      value: "7",
    },
  ],
  faults_detected: {
    title: "Faults",
    tooltip: "Faults Detected",
    header: [
      "Faults Detected",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "OK",
        value: "Ok",
        msg: "Devices with no faults.",
      },
      {
        label: "Interrupt",
        value: "INTERRUPT",
        msg: "Voltage drops to <10% of nominal (>= 10ms)",
      },
      {
        label: "Last Gasp",
        value: "LAST_GASP",
        msg: "Devices with last gasp.",
      },
      {
        label: "Loss Of Mains",
        value: "LOSS_OF_MAINS",
        msg: "Loss of grid connection detected when voltage falls below 10% of nominal (no duration reported)",
      },
    ],
  },
  power_quality_issues: {
    title: "Overview",
    tooltip: "Power Quality Issues",
    header: [
      "Power Quality Issues",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "No Problem",
        value: "Ok",
        msg: "Devices with no known issues.",
      },
      {
        label: "Rapid Voltage Change",
        value: "RAPID_VOLTAGE_CHANGE",
        msg: "Sudden voltage shift ≥5% from nominal, unrelated to dips/swells",
      },
      {
        label: "Dip",
        value: "DIP",
        msg: "Voltage decreases below 90% of nominal for 10 ms - 1 min",
      },
      {
        label: "Swell",
        value: "SWELL",
        msg: "Voltage rises above 110% of nominal for 10 ms - 1 min",
      },
    ],
  },
  compliance_issues: {
    title: "Compliance",
    subtitle: "Weekly",
    tooltip: "Compliance Issues",
    header: [
      "Compliance Issues",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    description: "Compliance data is derived from the EN50160 report and reflects measurements from the previous week.",
    data: [
      {
        label: "No Problem",
        value: "Ok",
        msg: "Devices with no known issues.",
      },
      {
        label: "Flicker Severity",
        value: "flicker_severity",
        msg: "Devices with flicker severity",
      },
      {
        label: "Power Frequency",
        value: "frequency",
        msg: "Devices with power frequency",
      },
      {
        label: "Total Harmonic Distortion",
        value: "vThd",
        msg: "Devices with total harmonic distortion",
      },
      {
        label: "Supply Voltage Variations",
        value: "vRms",
        msg: "Devices with supply voltage variations",
      },
      {
        label: "Harmonic Voltage",
        value: "harmonics",
        msg: "Devices with harmonic voltage",
      },
    ],
  },
  capacity_problems: {
    title: "Capacity",
    tooltip:
      "Capacity analysis measures the amount of capacity in use at each transformer and stratifies by overutilized, normal or underutilized.",
    header: [
      "Capacity",
      "Number of Devices",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Underutilized",
        value: "UNDERUTILIZED",
        msg: "Devices under current limit - Less than 15% Capacity",
      },
      {
        label: "Normal",
        value: "NORMAL",
        msg: "Devices with optimal current - Inbetween 15% and 85% Capacity ",
      },
      {
        label: "NA",
        value: "NA",
        msg: "Devices not yet installed.",
      },
      {
        label: "Overutilised",
        value: "OVERUTILIZED",
        msg: "Devices over current limit - More than 85% Capacity ",
      },
    ],
  },
  report_device_table: [
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Name",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "Transformer Rating",
      of_type: "text",
      value: "TransformerRating",
      suffix: "kVA",
    },
    {
      text: "Last Message Time",
      value: "Timestamp",
      of_type: "date",
    },
    {
      text: "Max Demenad",
      value: "Max Demenad",
      of_type: "text",
      suffix: "V",
    },
    {
      text: "Min Demand",
      value: "Min Demand",
      of_type: "text",
      suffix: "V",
    },
    {
      text: "THD",
      value: "VTHD",
      of_type: "text",
      suffix: "V",
    },
  ],
  latest_message_header: ["Feeders", "Active Power", "Reactive Power", "Apparent Power"],
  latest_message: [
    {
      label: "F1",
      values: ["F1_ActivePowerMean", "F1_ApparentPowerMean", "F1_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "KVAr"],
    },
    {
      label: "F2",
      values: ["F2_ActivePowerMean", "F2_ApparentPowerMean", "F2_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "kVAr"],
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: "F3",
      values: ["F3_ActivePowerMean", "F3_ApparentPowerMean", "F3_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "kVAr"],
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: "F4",
      values: ["F4_ActivePowerMean", "F4_ApparentPowerMean", "F4_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "kVAr"],
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: "F5",
      values: ["F5_ActivePowerMean", "F5_ApparentPowerMean", "F5_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "kVAr"],
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: "F6",
      values: ["F6_ActivePowerMean", "F6_ApparentPowerMean", "F6_ReactivePowerMean"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: ["KW", "kVA", "kVAr"],
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
  ],
  calculated_readings: [
    {
      label: i18n.t("views.Asset.calculatedReadings.totalPower.label"),
      value: "totalpower",
      suffix: i18n.t("views.Asset.calculatedReadings.totalPower.suffix"),
    },
    {
      label: i18n.t("views.Asset.calculatedReadings.utilization.label"),
      value: "utilisation",
      suffix: i18n.t("views.Asset.calculatedReadings.utilization.suffix"),
    },
    {
      label: i18n.t("views.Asset.calculatedReadings.imbalance.label"),
      value: "imbalance",
      suffix: i18n.t("views.Asset.calculatedReadings.imbalance.suffix"),
    },
  ],
  primary_filters: [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Watchlist",
      value: "Watchlist",
    },
  ],
  secondary_filters: {
    range: [
      {
        label: "Message Reliability",
        min: 0,
        max: 100,
        value: "MessageReliability",
      },
      {
        label: "Capacity",
        min: 0,
        max: 1500,
        value: "Capacity",
      },
      {
        label: "Transformer Rating",
        min: 0,
        max: 1500,
        value: "TransformerRating",
      },
    ],
  },
  filters: {
    All: [
      [
        { value: "Capacity", label: "Capacity", suffix: "%" },
        { value: "TotalPower", label: "Total Power", suffix: "KVA" },
      ],
      [
        {
          value: "MessageReliability",
          label: "Message Reliability",
          suffix: "KVA",
          type: "bar",
        },
      ],
    ],
    PQ: [
      [
        {
          value: "Fault",
          label: "",
          suffix: "KVA",
          type: "icon",
          icon: "mdi-alert-circle-outline",
          color: "warning",
        },
        {
          value: "Faults",
          label: "Active Fault(s)",
          type: "list",
          cols: 9,
          color: "accent",
        },
      ],
      [
        {
          value: "LastGasp",
          label: "Loss Of Mains",
          type: "date",
          icon: "mdi-alert-circle-outline",
          color: "lightCoral",
        },
      ],
    ],
    NZ: [
      [
        {
          value: "Capactity",
          label: "Capacity Today",
          suffix: "%",
          type: "vbar",
        },
        { value: "MaxCapacity7days", label: "Max Capacity over last 7 Days" },
        {
          value: "ProjectedCapacity",
          label: "Projected Capacity Yr",
        },
        { value: "MaxCapacity7days", label: "Max Capacity over last 7 Days" },
      ],
      [
        {
          value: "Rerating",
          label: "Rerating",
          type: "icon",
          icon: "mdi-sticker-alert-outline",
          color: "vtred",
        },
      ],
    ],
    TH: [
      [
        { value: "Temperature", label: "Temperature", suffix: "°C" },
        { value: "H2Lvl", label: "H2Lvl", suffix: "ppm" },
        { value: "H2RateOfChange", label: "H2RateOfChange", suffix: "°C" },
        { value: "TempRateOfChange", label: "TempRateOfChange", suffix: "ppm" },
      ],
      [{ value: "OverlaodRisk", label: "Overlaod Risk", type: "bar" }],
    ],
  },
  rollout_table: [
    {
      text: "",
      sortable: false,
      of_type: "indicator",
      valueOf: "DeviceStatus",
    },
    {
      align: "start",
      text: "Device ID",
      value: "DeviceID",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/scavenger/",
    },
    {
      text: "Name",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "Device Status",
      value: "DeviceStatus",
      of_type: "text",
    },
    {
      text: "Status Update",
      value: "StatusDate",
      of_type: "date",
    },
    {
      text: "Planner Group",
      value: "planner_group",
      of_type: "text",
    },
  ],
  rollout_planner_groups_table: [
    {
      text: "Planner Group",
      value: "planner_group",
      of_type: "text",
    },
    {
      text: "Total Sites",
      value: "total_sites",
      of_type: "text",
    },
    {
      text: "Active Sites",
      value: "active_sites",
      of_type: "text",
    },
    {
      text: "Inactive Sites",
      value: "inactive_sites",
      of_type: "text",
    },
    {
      text: "Status",
      values: ["active_sites", "inactive_sites"],
      labels: ["Active Site(s)", "Inactive Site(s)"],
      colors: ["vtblue", "vtred"],
      sortable: false,
      of_type: "bar",
    },
  ],
  rollout_sites_table: [
    {
      align: "start",
      text: i18n.t("common.labels.functionalLocation"),
      value: "asset_id",
      sortable: true,
      of_type: "text",
    },
    {
      text: "Name",
      value: "poi",
      of_type: "text",
    },
    {
      text: "Planner Group",
      value: "planner_group",
      of_type: "text",
    },
    {
      text: "Device Installed",
      value: "deviceActive",
      of_type: "switch",
      icon: "mdi-check-circle-outline",
      color: "success",
    },
  ],
  rollout_overview_stats: [
    {
      label: "All Devices",
      value: "devices",
      subtext: " installed.",
      icon: "mdi-map",
      color: "primaryOutline",
      type: "string",
    },
    {
      label: "All Planner Groups",
      value: "planner_groups",
      icon: "mdi-selection-marker",
      color: "primary",
      type: "string",
    },
    {
      label: "All Sites",
      value: "sites",
      subtext: " site(s) have active device.",
      icon: "mdi-map-marker-radius",
      color: "secondary",
      type: "string",
    },
  ],
  devices_table: [
    {
      align: "start",
      text: "Name",
      value: "TransformerName",
      sortable: true,
      of_type: "modal",
      identifier: "DeviceID",
      longValue: true,
    },
    {
      text: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
      of_type: "modal",
      identifier: "DeviceID",
    },
    {
      text: "Last Message Time",
      value: "Timestamp",
      of_type: "epoch",
    },
    {
      text: "L1_RMSVoltageMean",
      value: "L1_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "L2_RMSVoltageMean",
      value: "L2_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "L3_RMSVoltageMean",
      value: "L3_RMSVoltageMean",
      of_type: "number",
      suffix: "V",
    },
    {
      text: "Tags",
      value: "tags",
      of_type: "chips",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: ["Edit Details", "Open as a Page"],
    },
  ],
  pq_filters: {
    primary: [
      {
        label: "All",
        value: "All",
      },
      {
        label: "Watchlist",
        value: "Watchlist",
      },
    ],
  },
  devices_all: [
    {
      align: "start",
      text: "Device ID",
      value: "deviceId",
      sortable: true,
      of_type: "modal",
      ctrl_click: true,
    },
    {
      text: "Site",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "Transformer size",
      value: "TransformerRating",
      of_type: "text",
      suffix: " kVA",
    },
    {
      text: "Serial number",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Installation date",
      value: "StatusDate",
      of_type: "date",
    },
    {
      text: "Latest Readings",
      value: "LatestMessage",
      icon: "mdi-information-variant",
      values: [
        { value: "TotalPower", label: "Total Power", suffix: "KVA" },
        { value: "Capacity", label: "Capacity", suffix: "%" },
      ],
      of_type: "more_info",
    },
    {
      text: "Message Reliability",
      value: "MessageReliability",
      of_type: "perc",
      decimals: 0,
      tooltip: "% of messages received compared to the total expected messages.",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: "",
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: ["Edit Details", "Open as a Page"],
    },
  ],
  devices_nz: [
    {
      align: "start",
      text: "Device ID",
      value: "deviceId",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Capacity Today",
      value: "Capacity",
      of_type: "vbar",
    },
    {
      text: "Max capacity over last 7 days",
      value: "MaxCapacity7days",
      of_type: "number",
    },
    {
      text: "Projected capacity year",
      value: "ProjectedCapacity",
      of_type: "text",
    },
    {
      text: "Extreme weather",
      value: "extremeWeather",
      of_type: "number",
    },
    {
      text: "Rerating",
      value: "Rerating",
      of_type: "switch",
      icon: "mdi-sticker-alert-outline",
      color: "secondary",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_pq: [
    {
      align: "start",
      text: "Device ID",
      value: "deviceId",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Site",
      value: "TransformerName",
      of_type: "text",
    },
    {
      text: "",
      value: "Fault",
      of_type: "switch",
      icon: "mdi-alert-circle-outline",
      color: "secondary",
    },
    {
      text: "Faults",
      value: "Faults",
      of_type: "list",
      color: "accent",
    },
    {
      text: "Loss of mains event",
      value: "LastGasp",
      of_type: "date",
      color: "lightCoral",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  devices_th: [
    {
      align: "start",
      text: "Device ID",
      value: "deviceId",
      sortable: true,
      of_type: "modal",
    },
    {
      text: "Serial",
      value: "TransformerNo",
      of_type: "text",
    },
    {
      text: "Temperature",
      value: "Temperature",
      of_type: "number",
      suffix: "°C",
    },
    {
      text: "Temp rate of change",
      value: "TempRateOfChange",
      of_type: "number",
    },
    {
      text: "Hydrogen level",
      value: "H2Lvl",
      of_type: "number",
    },
    {
      text: "H₂ rate of change ",
      value: "H2RateOfChange",
      of_type: "number",
    },
    {
      text: "Accelerated ageing",
      value: "AccAgeing",
      of_type: "number",
    },
    {
      text: "Overload Risk",
      value: "OverlaodRisk",
      of_type: "perc",
    },
    {
      text: "",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  messages_table: [
    {
      align: "start",
      text: "Seq No",
      value: "seqNo",
      sortable: true,
      of_type: "text",
    },
    {
      text: "Message Time",
      value: "Timestamp",
      of_type: "epoch",
    },
    {
      value: "FrequencyMin",
      of_type: "number",
      text: "Frequency Min",
    },
    {
      value: "FrequencyMean",
      of_type: "number",
      text: "Frequency Mean",
    },
    {
      value: "FrequencyMax",
      of_type: "number",
      text: "Frequency Max",
    },
    {
      value: "L1_DisplacementPowerFactorMin",
      of_type: "number",
      text: "L1_DisplacementPowerFactorMin",
    },
    {
      value: "L1_DisplacementPowerFactorMean",
      of_type: "number",
      text: "L1_DisplacementPowerFactorMean",
    },
    {
      value: "L1_DisplacementPowerFactorMax",
      of_type: "number",
      text: "L1_DisplacementPowerFactorMax",
    },
    {
      value: "L2_DisplacementPowerFactorMin",
      of_type: "number",
      text: "L2_DisplacementPowerFactorMin",
    },
    {
      value: "L2_DisplacementPowerFactorMean",
      of_type: "number",
      text: "L2_DisplacementPowerFactorMean",
    },
    {
      value: "L2_DisplacementPowerFactorMax",
      of_type: "number",
      text: "L2_DisplacementPowerFactorMax",
    },
    {
      value: "L3_DisplacementPowerFactorMin",
      of_type: "number",
      text: "L3_DisplacementPowerFactorMin",
    },
    {
      value: "L3_DisplacementPowerFactorMean",
      of_type: "number",
      text: "L3_DisplacementPowerFactorMean",
    },
    {
      value: "L3_DisplacementPowerFactorMax",
      of_type: "number",
      text: "L3_DisplacementPowerFactorMax",
    },
    {
      value: "L1_RMSVoltageMean",
      of_type: "number",
      text: "L1_RMSVoltageMean",
    },
    {
      value: "L1_TotalHarmonicDistortionUMean",
      of_type: "number",
      text: "L1_TotalHarmonicDistortionUMean",
    },
    {
      value: "L2_RMSVoltageMean",
      of_type: "number",
      text: "L2_RMSVoltageMean",
    },
    {
      value: "L2_TotalHarmonicDistortionUMean",
      of_type: "number",
      text: "L2_TotalHarmonicDistortionUMean",
    },
    {
      value: "L3_RMSVoltageMean",
      of_type: "number",
      text: "L3_RMSVoltageMean",
    },
    {
      value: "L3_TotalHarmonicDistortionUMean",
      of_type: "number",
      text: "L3_TotalHarmonicDistortionUMean",
    },
    {
      value: "F1_L1_ActivePowerMean",
      of_type: "number",
      text: "F1_L1_ActivePowerMean",
    },
    {
      value: "F1_L1_ApparentPowerMean",
      of_type: "number",
      text: "F1_L1_ApparentPowerMean",
    },
    {
      value: "F1_L1_RMSCurrentMean",
      of_type: "number",
      text: "F1_L1_RMSCurrentMean",
    },
    {
      value: "F1_L1_ReactivePowerMean",
      of_type: "number",
      text: "F1_L1_ReactivePowerMean",
    },
    {
      value: "F1_L2_ActivePowerMean",
      of_type: "number",
      text: "F1_L2_ActivePowerMean",
    },
    {
      value: "F1_L2_ApparentPowerMean",
      of_type: "number",
      text: "F1_L2_ApparentPowerMean",
    },
    {
      value: "F1_L2_RMSCurrentMean",
      of_type: "number",
      text: "F1_L2_RMSCurrentMean",
    },
    {
      value: "F1_L2_ReactivePowerMean",
      of_type: "number",
      text: "F1_L2_ReactivePowerMean",
    },
    {
      value: "F1_L3_ActivePowerMean",
      of_type: "number",
      text: "F1_L3_ActivePowerMean",
    },
    {
      value: "F1_L3_ApparentPowerMean",
      of_type: "number",
      text: "F1_L3_ApparentPowerMean",
    },
    {
      value: "F1_L3_RMSCurrentMean",
      of_type: "number",
      text: "F1_L3_RMSCurrentMean",
    },
    {
      value: "F1_L3_ReactivePowerMean",
      of_type: "number",
      text: "F1_L3_ReactivePowerMean",
    },
    {
      value: "F1_N_ActivePowerMean",
      of_type: "number",
      text: "F1_N_ActivePowerMean",
    },
    {
      value: "F1_N_ApparentPowerMean",
      of_type: "number",
      text: "F1_N_ApparentPowerMean",
    },
    {
      value: "F1_N_RMSCurrentMean",
      of_type: "number",
      text: "F1_N_RMSCurrentMean",
    },
    {
      value: "F1_N_ReactivePowerMean",
      of_type: "number",
      text: "F1_N_ReactivePowerMean",
    },
    {
      value: "F2_L1_ActivePowerMean",
      of_type: "number",
      text: "F2_L1_ActivePowerMean",
    },
    {
      value: "F2_L1_ApparentPowerMean",
      of_type: "number",
      text: "F2_L1_ApparentPowerMean",
    },
    {
      value: "F2_L1_RMSCurrentMean",
      of_type: "number",
      text: "F2_L1_RMSCurrentMean",
    },
    {
      value: "F2_L1_ReactivePowerMean",
      of_type: "number",
      text: "F2_L1_ReactivePowerMean",
    },
    {
      value: "F2_L2_ActivePowerMean",
      of_type: "number",
      text: "F2_L2_ActivePowerMean",
    },
    {
      value: "F2_L2_ApparentPowerMean",
      of_type: "number",
      text: "F2_L2_ApparentPowerMean",
    },
    {
      value: "F2_L2_RMSCurrentMean",
      of_type: "number",
      text: "F2_L2_RMSCurrentMean",
    },
    {
      value: "F2_L2_ReactivePowerMean",
      of_type: "number",
      text: "F2_L2_ReactivePowerMean",
    },
    {
      value: "F2_L3_ActivePowerMean",
      of_type: "number",
      text: "F2_L3_ActivePowerMean",
    },
    {
      value: "F2_L3_ApparentPowerMean",
      of_type: "number",
      text: "F2_L3_ApparentPowerMean",
    },
    {
      value: "F2_L3_RMSCurrentMean",
      of_type: "number",
      text: "F2_L3_RMSCurrentMean",
    },
    {
      value: "F2_L3_ReactivePowerMean",
      of_type: "number",
      text: "F2_L3_ReactivePowerMean",
    },
    {
      value: "F2_N_ActivePowerMean",
      of_type: "number",
      text: "F2_N_ActivePowerMean",
    },
    {
      value: "F2_N_ApparentPowerMean",
      of_type: "number",
      text: "F2_N_ApparentPowerMean",
    },
    {
      value: "F2_N_RMSCurrentMean",
      of_type: "number",
      text: "F2_N_RMSCurrentMean",
    },
    {
      value: "F2_N_ReactivePowerMean",
      of_type: "number",
      text: "F2_N_ReactivePowerMean",
    },
    {
      value: "F3_L1_ActivePowerMean",
      of_type: "number",
      text: "F3_L1_ActivePowerMean",
    },
    {
      value: "F3_L1_ApparentPowerMean",
      of_type: "number",
      text: "F3_L1_ApparentPowerMean",
    },
    {
      value: "F3_L1_RMSCurrentMean",
      of_type: "number",
      text: "F3_L1_RMSCurrentMean",
    },
    {
      value: "F3_L1_ReactivePowerMean",
      of_type: "number",
      text: "F3_L1_ReactivePowerMean",
    },
    {
      value: "F3_L2_ActivePowerMean",
      of_type: "number",
      text: "F3_L2_ActivePowerMean",
    },
    {
      value: "F3_L2_ApparentPowerMean",
      of_type: "number",
      text: "F3_L2_ApparentPowerMean",
    },
    {
      value: "F3_L2_RMSCurrentMean",
      of_type: "number",
      text: "F3_L2_RMSCurrentMean",
    },
    {
      value: "F3_L2_ReactivePowerMean",
      of_type: "number",
      text: "F3_L2_ReactivePowerMean",
    },
    {
      value: "F3_L3_ActivePowerMean",
      of_type: "number",
      text: "F3_L3_ActivePowerMean",
    },
    {
      value: "F3_L3_ApparentPowerMean",
      of_type: "number",
      text: "F3_L3_ApparentPowerMean",
    },
    {
      value: "F3_L3_RMSCurrentMean",
      of_type: "number",
      text: "F3_L3_RMSCurrentMean",
    },
    {
      value: "F3_L3_ReactivePowerMean",
      of_type: "number",
      text: "F3_L3_ReactivePowerMean",
    },
    {
      value: "F3_N_ActivePowerMean",
      of_type: "number",
      text: "F3_N_ActivePowerMean",
    },
    {
      value: "F3_N_ApparentPowerMean",
      of_type: "number",
      text: "F3_N_ApparentPowerMean",
    },
    {
      value: "F3_N_RMSCurrentMean",
      of_type: "number",
      text: "F3_N_RMSCurrentMean",
    },
    {
      value: "F3_N_ReactivePowerMean",
      of_type: "number",
      text: "F3_N_ReactivePowerMean",
    },
    {
      value: "F4_L1_ActivePowerMean",
      of_type: "number",
      text: "F4_L1_ActivePowerMean",
    },
    {
      value: "F4_L1_ApparentPowerMean",
      of_type: "number",
      text: "F4_L1_ApparentPowerMean",
    },
    {
      value: "F4_L1_RMSCurrentMean",
      of_type: "number",
      text: "F4_L1_RMSCurrentMean",
    },
    {
      value: "F4_L1_ReactivePowerMean",
      of_type: "number",
      text: "F4_L1_ReactivePowerMean",
    },
    {
      value: "F4_L2_ActivePowerMean",
      of_type: "number",
      text: "F4_L2_ActivePowerMean",
    },
    {
      value: "F4_L2_ApparentPowerMean",
      of_type: "number",
      text: "F4_L2_ApparentPowerMean",
    },
    {
      value: "F4_L2_RMSCurrentMean",
      of_type: "number",
      text: "F4_L2_RMSCurrentMean",
    },
    {
      value: "F4_L2_ReactivePowerMean",
      of_type: "number",
      text: "F4_L2_ReactivePowerMean",
    },
    {
      value: "F4_L3_ActivePowerMean",
      of_type: "number",
      text: "F4_L3_ActivePowerMean",
    },
    {
      value: "F4_L3_ApparentPowerMean",
      of_type: "number",
      text: "F4_L3_ApparentPowerMean",
    },
    {
      value: "F4_L3_RMSCurrentMean",
      of_type: "number",
      text: "F4_L3_RMSCurrentMean",
    },
    {
      value: "F4_L3_ReactivePowerMean",
      of_type: "number",
      text: "F4_L3_ReactivePowerMean",
    },
    {
      value: "F4_N_ActivePowerMean",
      of_type: "number",
      text: "F4_N_ActivePowerMean",
    },
    {
      value: "F4_N_ApparentPowerMean",
      of_type: "number",
      text: "F4_N_ApparentPowerMean",
    },
    {
      value: "F4_N_RMSCurrentMean",
      of_type: "number",
      text: "F4_N_RMSCurrentMean",
    },
    {
      value: "F4_N_ReactivePowerMean",
      of_type: "number",
      text: "F4_N_ReactivePowerMean",
    },
    {
      value: "F5_L1_ActivePowerMean",
      of_type: "number",
      text: "F5_L1_ActivePowerMean",
    },
    {
      value: "F5_L1_ApparentPowerMean",
      of_type: "number",
      text: "F5_L1_ApparentPowerMean",
    },
    {
      value: "F5_L1_RMSCurrentMean",
      of_type: "number",
      text: "F5_L1_RMSCurrentMean",
    },
    {
      value: "F5_L1_ReactivePowerMean",
      of_type: "number",
      text: "F5_L1_ReactivePowerMean",
    },
    {
      value: "F5_L2_ActivePowerMean",
      of_type: "number",
      text: "F5_L2_ActivePowerMean",
    },
    {
      value: "F5_L2_ApparentPowerMean",
      of_type: "number",
      text: "F5_L2_ApparentPowerMean",
    },
    {
      value: "F5_L2_RMSCurrentMean",
      of_type: "number",
      text: "F5_L2_RMSCurrentMean",
    },
    {
      value: "F5_L2_ReactivePowerMean",
      of_type: "number",
      text: "F5_L2_ReactivePowerMean",
    },
    {
      value: "F5_L3_ActivePowerMean",
      of_type: "number",
      text: "F5_L3_ActivePowerMean",
    },
    {
      value: "F5_L3_ApparentPowerMean",
      of_type: "number",
      text: "F5_L3_ApparentPowerMean",
    },
    {
      value: "F5_L3_RMSCurrentMean",
      of_type: "number",
      text: "F5_L3_RMSCurrentMean",
    },
    {
      value: "F5_L3_ReactivePowerMean",
      of_type: "number",
      text: "F5_L3_ReactivePowerMean",
    },
    {
      value: "F5_N_ActivePowerMean",
      of_type: "number",
      text: "F5_N_ActivePowerMean",
    },
    {
      value: "F5_N_ApparentPowerMean",
      of_type: "number",
      text: "F5_N_ApparentPowerMean",
    },
    {
      value: "F5_N_RMSCurrentMean",
      of_type: "number",
      text: "F5_N_RMSCurrentMean",
    },
    {
      value: "F5_N_ReactivePowerMean",
      of_type: "number",
      text: "F5_N_ReactivePowerMean",
    },
    {
      value: "F6_L1_ActivePowerMean",
      of_type: "number",
      text: "F6_L1_ActivePowerMean",
    },
    {
      value: "F6_L1_ApparentPowerMean",
      of_type: "number",
      text: "F6_L1_ApparentPowerMean",
    },
    {
      value: "F6_L1_RMSCurrentMean",
      of_type: "number",
      text: "F6_L1_RMSCurrentMean",
    },
    {
      value: "F6_L1_ReactivePowerMean",
      of_type: "number",
      text: "F6_L1_ReactivePowerMean",
    },
    {
      value: "F6_L2_ActivePowerMean",
      of_type: "number",
      text: "F6_L2_ActivePowerMean",
    },
    {
      value: "F6_L2_ApparentPowerMean",
      of_type: "number",
      text: "F6_L2_ApparentPowerMean",
    },
    {
      value: "F6_L2_RMSCurrentMean",
      of_type: "number",
      text: "F6_L2_RMSCurrentMean",
    },
    {
      value: "F6_L2_ReactivePowerMean",
      of_type: "number",
      text: "F6_L2_ReactivePowerMean",
    },
    {
      value: "F6_L3_ActivePowerMean",
      of_type: "number",
      text: "F6_L3_ActivePowerMean",
    },
    {
      value: "F6_L3_ApparentPowerMean",
      of_type: "number",
      text: "F6_L3_ApparentPowerMean",
    },
    {
      value: "F6_L3_RMSCurrentMean",
      of_type: "number",
      text: "F6_L3_RMSCurrentMean",
    },
    {
      value: "F6_L3_ReactivePowerMean",
      of_type: "number",
      text: "F6_L3_ReactivePowerMean",
    },
    {
      value: "F6_N_ActivePowerMean",
      of_type: "number",
      text: "F6_N_ActivePowerMean",
    },
    {
      value: "F6_N_ApparentPowerMean",
      of_type: "number",
      text: "F6_N_ApparentPowerMean",
    },
    {
      value: "F6_N_RMSCurrentMean",
      of_type: "number",
      text: "F6_N_RMSCurrentMean",
    },
    {
      value: "F6_N_ReactivePowerMean",
      of_type: "number",
      text: "F6_N_ReactivePowerMean",
    },
    {
      text: "Message Time ISO",
      value: "TimestampISO",
      of_type: "date",
      sortable: true,
    },
  ],
  maps_config: {
    id: "DeviceID",
    infoText: "DeviceID",
    label: "",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "scavenger",
    type: "Type",
    datatype: "powerdata",
  },
  infoWindowItemsConfig: [
    {
      id: "TransformerName",
      icon: "mdi-square-inc",
    },
    {
      id: "L1_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
      phase: "L1",
    },
    {
      id: "L2_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
      phase: "L2",
    },
    {
      id: "L3_RMSVoltageMean",
      icon: "mdi-flash",
      suffix: "V",
      phase: "L3",
    },
    {
      id: "TransformerRating",
      icon: "mdi-flash",
      suffix: "kVA",
    },
  ],
  maps_rollout_config: {
    id: "DeviceID",
    infoText: "DeviceID",
    label: "DeviceID",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "scavenger",
    type: "DeviceStatus",
    deviceType: "Type",
    userType: "scv",
    country: "Country",
    adminArea: "planner_group",
    status: "DeviceStatus",
    suffix: "device(s)",
  },
  maps_sites_rollout_config: {
    id: "location_id",
    infoText: "poi",
    label: "poi",
    lat: "latitude",
    lng: "longitude",
    url: "scavenger",
    type: "deviceActive",
    country: "country",
    adminArea: "planner_group",
    status: "deviceActive",
    isStatusBoolean: true,
    suffix: "site(s)",
  },
  rollout_chart: {
    id: "rollout_chart",
    label: "Device Status",
    seriesType: "lines",
    series: {
      0: {
        type: "bars",
      },
      2: {
        type: "bars",
      },
    },
    xAxis: "Installation Month-Year",
    yAxis: "Number of Devices",
    colors: ["#a1c7e2", "#325597", "#101c49", "#52a0d2", "#f4be5e"],
    areaColors: ["#8181a5", "#101c49", "#FF8A80", "#52a0d2", "#f4be5e"],
  },
  utilization_chart: {
    isStacked: true,
    displayAnnotations: true,
    seriesType: "bars",
    series: {
      0: {
        type: "bars",
      },
      1: {
        type: "bars",
      },
      2: {
        type: "line",
        lineWidth: 2,
        pointSize: 0,
        displayAnnotations: true,
        lineDashStyle: [5, 5],
      },
    },
    xAxis: "Installation Month-Year",
    yAxis: "Number of Devices",
    colors: ["#bbc492", "#c63e12", "#1b428b", "#52a0d2", "#f4be5e"],
    areaColors: ["#bbc492", "#c63e12", "#1b428b", "#52a0d2", "#f4be5e"],
  },
  max_supported_LCTs_chart: {
    colors: ["#c63e12", "#bbc492", "#1b428b", "#52a0d2", "#f4be5e"],
  },
  lct_growth: {
    colors: ["#c63e12", "#bbc492", "#1b428b", "#52a0d2", "#f4be5e"],
  },
  advise_map_config: {
    id: "ID",
    infoText: "ID",
    label: "Name",
    lat: "Latitude",
    lng: "Longitude",
    url: "scavenger",
    datatype: "powerdata",
  },
  fleet_chart: {
    id: "fleet_chart",
    label: "Transformer Fleet Status on Worst TUF Day with LCT Uptake",
    seriesType: "lines",
    series: {
      0: {
        type: "bars",
      },
      2: {
        type: "bars",
      },
    },
    xAxis: "Utilization Band",
    yAxis: "Number of Transformers",
    colors: ["#d99a52", "#325597", "#101c49", "#52a0d2", "#f4be5e"],
    areaColors: ["#d99a52", "#101c49", "#FF8A80", "#52a0d2", "#f4be5e"],
  },
  fleet_status_over_years: {
    id: "fleet_status_over_year_chart",
    label: "Number of Transformers Overload over Years",
    seriesType: "lines",
    series: {
      0: {
        type: "bars",
      },
      2: {
        type: "bars",
      },
    },
    xAxis: "Years",
    yAxis: "Number of Transformers",
    colors: ["#d99a52", "#325597", "#101c49", "#52a0d2", "#f4be5e"],
    areaColors: ["#d99a52", "#101c49", "#FF8A80", "#52a0d2", "#f4be5e"],
    filters: [">80%", ">100%", ">120%"],
  },
  maps_advise_config: {
    id: "id",
    infoText: "poi",
    label: "PlannerGroup",
    lat: "Latitude",
    lng: "Longitude",
    url: "scavenger",
    type: "deviceActive",
    adminArea: "PlannerGroup",
    status: "TUF",
    suffix: "Transformer(s)",
  },
  advise_device_details: [
    {
      label: "Transformer  ",
      value: "Name",
    },
    {
      label: "Planner Group",
      value: "PlannerGroup",
    },
    {
      label: "County",
      value: "County",
    },
    {
      label: "Transformer Rating",
      value: "Rating",
      suffix: "kVA",
    },
    {
      label: "TUF Max",
      value: "TUFmax",
    },
    {
      label: "Feeders",
      value: "Feeders",
    },
    {
      label: "Connected MPRNs",
      value: "MPRNs",
    },
    {
      label: "Monitoring Start Date",
      value: "StatusDate",
      type: "date",
    },
    {
      label: "Year of Installation",
      value: "InstallationYear",
    },
  ],
  advise_table: [
    {
      align: "start",
      text: "Device ID",
      value: "ID",
      sortable: true,
      of_type: "modal",
      identifier: "ID",
    },
    {
      text: "Name",
      value: "Name",
      of_type: "text",
    },
    {
      text: "Lattitude",
      value: "Latitude",
      of_type: "text",
    },
    {
      text: "Longitude",
      value: "Longitude",
      of_type: "text",
    },
    {
      text: "Planner Group",
      value: "PlannerGroup",
      of_type: "text",
    },
    {
      text: "County",
      value: "County",
      of_type: "text",
    },
    {
      text: "TUFmax",
      value: "TUFmax",
      of_type: "text",
    },
    {
      text: "Year of Overload",
      value: "Year of Overload",
      of_type: "text",
    },
    {
      text: "Feeders",
      value: "Feeders",
      of_type: "text",
    },
    {
      text: "MPRNs",
      value: "MPRNs",
      of_type: "text",
    },
  ],
  tabs: [
    {
      label: "Charts",
      id: "charts",
    },
    {
      label: "Messages",
      id: "messages",
    },
    {
      label: "Trends Data",
      id: "rms_data",
    },
    {
      label: "Capacity",
      id: "capacity",
    },
    {
      label: "Events",
      id: "events",
    },
    {
      label: "Fault Records",
      id: "faults",
    },
    {
      label: "XFRMR Health",
      id: "xfrmr",
    },
    {
      label: "Metering",
      id: "metering",
    },
    {
      label: "Images",
      id: "images",
    },
    {
      label: "Reporting",
      id: "reporting",
    },
    {
      label: "Advanced Alerts",
      id: "advanced_alerts",
    },
  ],
  advanced_alerts_config: [
    {
      id: "low_voltage",
      alarm_type: "Low Voltage",
      on_threshold: "218 V",
      on_time_period: "3 minutes",
      off_threshold: "220 V",
      off_time_period: "3 minutes",
    },
    {
      id: "high_voltage",
      alarm_type: "High Voltage",
      on_threshold: "254 V",
      on_time_period: "3 minutes",
      off_threshold: "220 V",
      off_time_period: "251 minutes",
    },
    {
      id: "transformer_long_term_overload",
      alarm_type: "Transformer Long Term Overload",
      on_threshold: "Apparent Power 500 kVA <br/> Current 667 A",
      on_time_period: "60 minutes",
      off_threshold: "Apparent Power 450 kVA <br/> Current 585 A",
      off_time_period: "60 minutes",
    },
    {
      id: "transformer_short_term_overload",
      alarm_type: "Transformer Short Term Overload",
      on_threshold: "Apparent Power 650 kVA <br/> Current 867 A",
      on_time_period: "30 minutes",
      off_threshold: "Apparent Power 585 kVA <br/> Current 780 A",
      off_time_period: "30 minutes",
    },
    {
      id: "feeder_phase_long_term_overload",
      alarm_type: "Feeder Long Term Overload",
      on_threshold: "335 A",
      on_time_period: "60 minutes",
      off_threshold: "268 A",
      off_time_period: "30 minutes",
    },
    {
      id: "feeder_phase_short_term_overload",
      alarm_type: "Feeder Short Term Overload",
      on_threshold: "335 A",
      on_time_period: "30 minutes",
      off_threshold: "268 A",
      off_time_period: "30 minutes",
    },
    {
      id: "feeder_neutral_current",
      alarm_type: "Feeder Neutral Current",
      on_threshold: "100 A",
      on_time_period: "60 minutes",
      off_threshold: "90 A",
      off_time_period: "60 minutes",
    },
    {
      id: "feeder_reverse_power_flow",
      alarm_type: "Feeder Reverse Power Flow",
      on_threshold: "-10 kVA",
      on_time_period: "60 minutes",
      off_threshold: "-9 kVA",
      off_time_period: "30 minutes",
    },
    {
      id: "feeder_fault_current",
      alarm_type: "Feeder Fault Current",
      on_threshold: "1500 A",
      on_time_period: "0",
      off_threshold: "1000 A",
      off_time_period: "0",
    },
    {
      id: "pre_fault_trigger",
      alarm_type: "Pre Fault Trigger",
      on_threshold: "315 A",
      on_time_period: "0",
      off_threshold: "300 A",
      off_time_period: "0",
    },
    {
      id: "fuse_blown",
      alarm_type: "Fuse Blown",
      on_threshold: "Short Circuit 475 A <br/> Null 5 A",
      on_time_period: "Transition 1000 ms",
      off_threshold: "Short Circuit 460 A <br/> Null 10 A",
      off_time_period: "5 seconds",
    },
  ],
  advanced_alerts_config_headers: [
    {
      text: "Alarm Type",
      value: "alarm_type",
      of_type: "text",
    },
    {
      text: "On Threshold",
      value: "on_threshold",
      of_type: "raw_html",
    },
    {
      text: "On Time Period",
      value: "on_time_period",
      of_type: "text",
    },
    {
      text: "Off Threshold",
      value: "off_threshold",
      of_type: "raw_html",
    },
    {
      text: "Off Time Period",
      value: "off_time_period",
      of_type: "text",
    },
    {
      text: "",
      value: "is_active",
      id: "id",
      of_type: "toggle_switch",
    },
  ],
  pq_issue_distrubution: {
    title: "PQ Issues",
    tooltip: "Distribution of different PQ issues (voltage dips, surges, harmonics, etc.) based on recorded events.",
    header: [
      "PQ Issues",
      "Number of Issues",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Rapid Voltage Change",
        value: "RAPID_VOLTAGE_CHANGE",
        msg: "Devices  with rapid voltage change.",
      },
      {
        label: "Dip",
        value: "DIP",
        msg: "Devices with dip.",
      },
      {
        label: "Swell",
        value: "SWELL",
        msg: "Devices with swell.",
      },
      {
        label: "Interrupt",
        value: "INTERRUPT",
        msg: "Devices with interruption.",
      },
      {
        label: "Loss Of Mains",
        value: "LOSS_OF_MAINS",
        msg: "Devices with loss of mains.",
      },
      {
        label: "Flicker",
        value: "FLICKER",
        msg: "Devices with flicker.",
      },
    ],
  },
  chart_prop_selection: ["Mean", "Max", "Min"],
  metering: [
    {
      id: "energy_metering",
      headings: ["Energy Metering", "Import", "Export"],
      values: [
        ["Active Energy", "ActiveEnergyImport", "ActiveEnergyExport"],
        ["Reactive Energy", "ReactiveEnergyImport", "ReactiveEnergyExport"],
      ],
      units: ["kW", "kVAr"],
    },
    {
      id: "acc_power",
      headings: ["Accumulated Power", "L1", "L2", "L3"],
      values: [
        [
          "Active Power",
          "L1_Total_Accumulated_ActivePower",
          "L2_Total_Accumulated_ActivePower",
          "L3_Total_Accumulated_ActivePower",
        ],
        [
          "Reactive Power",
          "L1_Total_Accumulated_ReactivePower",
          "L2_Total_Accumulated_ReactivePower",
          "L3_Total_Accumulated_ReactivePower",
        ],
        [
          "Apparent Power",
          "L1_Total_Accumulated_ApparentPower",
          "L2_Total_Accumulated_ApparentPower",
          "L3_Total_Accumulated_ApparentPower",
        ],
      ],
      units: ["kW", "kVAr", "kVA"],
    },
  ],
  data_fields: [
    "F1L1ApparentPowerMax",
    "F1L2ApparentPowerMax",
    "F1L3ApparentPowerMax",
    "F2L1ApparentPowerMax",
    "F2L2ApparentPowerMax",
    "F2L3ApparentPowerMax",
  ],
  trends_data_treeview_fields: [
    {
      id: "RMSVoltage",
      name: "Voltage",
      locked: false,
    },
    {
      id: "Frequency",
      name: "Frequency",
      locked: false,
    },
    {
      id: "feeder_1",
      name: "Feeder 1",
      index: 0,
      locked: false,
      children: [
        {
          id: "F1_Current",
          name: "Current",
          locked: false,
        },
        {
          id: "feeder_1_power_flow",
          name: "Power",
          locked: false,
          children: [
            {
              id: "F1_ActivePower",
              name: "Active",
            },
            {
              id: "F1_ReactivePower",
              name: "Reactive",
              locked: false,
            },
            {
              id: "F1_ApparentPower",
              name: "Apparent",
              locked: false,
            },
          ],
        },
      ],
    },
    {
      id: "feeder_2",
      name: "Feeder 2",
      index: 1,
      locked: false,
      children: [
        {
          id: "F2_Current",
          name: "Current",
        },
        {
          id: "feeder_2_power_flow",
          name: "Power",
          locked: false,
          children: [
            {
              id: "F2_ActivePower",
              name: "Active",
            },
            {
              id: "F2_ReactivePower",
              name: "Reactive",
            },
            {
              id: "F2_ApparentPower",
              name: "Apparent",
            },
          ],
        },
      ],
    },
    {
      id: "feeder_3",
      name: "Feeder 3",
      index: 2,
      locked: false,
      children: [
        {
          id: "F3_Current",
          name: "Current",
        },
        {
          id: "feeder_3_power_flow",
          name: "Power",
          locked: false,
          children: [
            {
              id: "F3_ActivePower",
              name: "Active",
            },
            {
              id: "F3_ReactivePower",
              name: "Reactive",
            },
            {
              id: "F3_ApparentPower",
              name: "Apparent",
            },
          ],
        },
      ],
    },
    {
      id: "feeder_4",
      name: "Feeder 4",
      index: 3,
      locked: false,
      children: [
        {
          id: "F4_Current",
          name: "Current",
          locked: false,
        },
        {
          id: "feeder_4_power_flow",
          name: "Power",
          locked: false,
          children: [
            {
              id: "F4_ActivePower",
              name: "Active",
              locked: false,
            },
            {
              id: "F4_ReactivePower",
              name: "Reactive",
              locked: false,
            },
            {
              id: "F4_ApparentPower",
              name: "Apparent",
              locked: false,
            },
          ],
        },
      ],
    },
    {
      id: "feeder_5",
      name: "Feeder 5",
      index: 4,
      locked: false,
      children: [
        {
          id: "F5_Current",
          name: "Current",
          locked: false,
        },
        {
          id: "feeder_5_power_flow",
          name: "Power",
          children: [
            {
              id: "F5_ActivePower",
              name: "Active",
            },
            {
              id: "F5_ReactivePower",
              name: "Reactive",
            },
            {
              id: "F5_ApparentPower",
              name: "Apparent",
            },
          ],
        },
      ],
    },
    {
      id: "feeder_6",
      name: "Feeder 6",
      index: 5,
      locked: false,
      children: [
        {
          id: "F6_Current",
          name: "Current",
        },
        {
          id: "feeder_6_power_flow",
          name: "Power",
          children: [
            {
              id: "F6_ActivePower",
              name: "Active",
            },
            {
              id: "F6_ReactivePower",
              name: "Reactive",
            },
            {
              id: "F6_ApparentPower",
              name: "Apparent",
            },
          ],
        },
      ],
    },
  ],
  charts: [
    {
      id: "voltage",
      type: "line",
    },
    {
      id: "power",
      type: "line",
    },
  ],
  box_plot: [
    {
      id: "thd",
      type: "candle",
    },
    {
      id: "voltage",
      type: "candle",
    },
  ],
  chart_config: {
    boxplot: {
      thd: {
        id: "thd",
        type: "candle",
        label: "THD (Voltage)",
        xAxis: "TimeStamp",
        yAxis: "%",
        colors: ["#1b428b"],
        max: 8,
        suffix: "%",
        margin: 5,
      },
      voltage: {
        id: "voltage_rms",
        type: "candle",
        label: "Voltage",
        xAxis: "TimeStamp",
        yAxis: "V",
        colors: ["#1b428b"],
        nom: 230,
        min: 207,
        max: 253,
        suffix: "V",
        margin: 10,
      },
      power: {
        id: "power_r",
        type: "candle",
        label: "Power (kVAr)",
        xAxis: "TimeStamp",
        yAxis: "VA",
        colors: ["#1b428b"],
        nom: 230,
        min: 207,
        max: 253,
        suffix: "kVAr",
        margin: 10,
      },
    },
  },
  chart_config_lightning: [
    {
      id: "voltage",
      type: "line",
      label: "RMS Voltage (V)",
      xAxis: "TimeStamp",
      yAxis: "Volatge (V)",
      strokeWidth: 3,
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d", "#0581c6", "#e14615", "#f08080", "#B62C41"],
      nom: 230,
      min: 207,
      max: 253,
      margin: 10,
      suffix: "V",
      dataLimit: 1,
    },
    {
      id: "power_active",
      type: "line",
      label: "Active Power",
      xAxis: "TimeStamp",
      yAxis: "Power (kW)",
      strokeWidth: 3,
      colors: ["#0581c6", "#e14615", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#a1c7e2", "#e4592c"],
      suffix: "kW",
      dataLimit: 1,
    },
    {
      id: "power_reactive",
      type: "line",
      label: "Reactive Power",
      xAxis: "TimeStamp",
      yAxis: "Power (kVAr)",
      strokeWidth: 3,
      colors: ["#0581c6", "#e14615", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#a1c7e2", "#e4592c"],
      suffix: "kVAr",
      dataLimit: 1,
    },
    {
      id: "power_apparent",
      type: "line",
      label: "Apparent Power",
      xAxis: "TimeStamp",
      yAxis: "Power (kVA)",
      strokeWidth: 3,
      colors: ["#0581c6", "#e14615", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#a1c7e2", "#e4592c"],
      suffix: "kVA",
      dataLimit: 1,
    },
  ],
  chart_config_temp_sensor: [
    {
      id: "Sensor_temperature",
      type: "line",
      label: "Temperature",
      xAxis: "TimeStamp",
      yAxis: "Temperature (C)",
      strokeWidth: 3,
      colors: ["#0581c6", "#e14615", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#a1c7e2", "#e4592c"],
      suffix: "kVA",
      dataLimit: 1,
    },
  ],
  chart_config_ambient_temp_lightning: [
    {
      id: "ambient_temp",
      type: "line",
      label: "Ambient Temperature",
      xAxis: "TimeStamp",
      yAxis: "Ambient Temperature (C)",
      strokeWidth: 3,
      colors: ["#0581c6"],
      suffix: "",
      dataLimit: 1,
    },
  ],
  scavenger_charts: {
    RMSVoltage: {
      id: "RMSVoltage",
      label: "RMS Voltage",
      values: ["L1", "L2", "L3"],
      yAxis: "RMS Voltage",
      suffix: "V",
      nom: 230,
      min: 207,
      max: 253,
      show: true,
      feeder: false,
      category: "pq",
    },
    ActivePower: {
      id: "ActivePower",
      label: "Active Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Active Power",
      suffix: "kW",
      show: true,
      feeder: true,
      category: "pq",
    },
    ReactivePower: {
      id: "ReactivePower",
      label: "Reactive Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Reactive Power",
      suffix: "kVAr",
      show: true,
      feeder: true,
      category: "pq",
    },
    ApparentPower: {
      id: "ApparentPower",
      label: "Apparent Power",
      values: ["L1", "L2", "L3"],
      yAxis: "Apparent Power",
      suffix: "kVA",
      show: true,
      feeder: true,
      category: "pq",
    },
    Temperature: {
      id: "Temp",
      label: "Temperature",
      values: ["Ambient", "Internal"],
      yAxis: "Temperature",
      suffix: "C",
      show: true,
      category: "pq",
      isTemperature: true,
    },
    H2: {
      id: "H2ppmCrt",
      label: "Hydrogen",
      values: [null],
      yAxis: "Hydrogen",
      suffix: "ppm",
      max: 5800,
      nom: 4000,
      average_threshold: true,
      show: true,
      category: "h2",
    },
    OilTemperature: {
      id: "TempOil",
      label: "Oil Temperature",
      values: [null],
      yAxis: "Oil Temperature",
      suffix: "C",
      max: 130,
      nom: 120,
      average_threshold: true,
      show: true,
      category: "h2",
      isTemperature: true,
    },
    AmbientTemperature: {
      id: "Temperature",
      label: "Ambient Temperature",
      values: [null],
      yAxis: "Ambient Temperature",
      suffix: "C",
      show: false,
      category: "ambient_temperature",
      isTemperature: true,
    },
    Current: {
      id: "Current",
      label: "Current",
      values: ["L1", "L2", "L3"],
      yAxis: "Current",
      suffix: "A",
      show: true,
      feeder: true,
      category: "pq",
    },
    Imbalance: {
      id: "Imbalance",
      label: "Imbalance",
      values: [null],
      yAxis: "Imbalance",
      suffix: "%",
      show: true,
    },
    Frequency: {
      id: "Frequency",
      label: "Frequency",
      values: [null],
      yAxis: "Frequency",
      suffix: "Hz",
      show: true,
      feeder: false,
      category: "pq",
    },
    Moisture: {
      id: "Moisture",
      label: "Moisture",
      values: [null],
      yAxis: "Moisture",
      suffix: "%",
      max: 60,
      nom: 50,
      average_threshold: true,
      show: true,
      category: "h2",
    },
    Pressure: {
      id: "Pressure",
      label: "Pressure",
      values: [null],
      yAxis: "Pressure",
      suffix: "psi",
      max: 15,
      nom: 10,
      average_threshold: true,
      show: true,
      category: "h2",
    },
    WindSpeed: {
      id: "WindSpeed",
      label: "Wind Speed",
      values: [null],
      yAxis: "Wind Speed",
      suffix: "m/s",
      show: false,
      category: "weather",
    },
    Solar: {
      id: "Solar",
      label: "Solar",
      values: [null],
      yAxis: "Solar magnitude",
      suffix: "Wh/m2", //watt hour per square metre
      show: false,
      category: "weather",
    },
    TotalPower: {
      id: "TotalPower",
      label: "Total Power",
      values: [null],
      yAxis: "Total Power",
      suffix: "kW",
      show: true,
      category: "total_power",
    },
    MaxTotalPower: {
      id: "MaxTotalPower",
      label: "Max Total Power",
      values: [null],
      yAxis: "Max Total Power",
      suffix: "kW",
      show: true,
      category: "total_power",
    },
  },
  feeder_keys: {
    f0: "F1",
    f1: "F2",
    f2: "F3",
    f3: "F4",
    f4: "F5",
    f5: "F6",
  },
  trends_data_chart_config: [
    {
      id: "Voltage",
      label: "Voltage",
      xAxis: "TimeStamp",
      yAxis: "Voltage",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      suffix: "V",
    },
    {
      id: "F1_Current",
      label: "Feeder 1 - Current",
      xAxis: "TimeStamp",
      yAxis: "Current",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      suffix: "A",
    },
    {
      id: "F1_Active",
      label: "Feeder 1 - Active",
      xAxis: "TimeStamp",
      yAxis: "Power",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      suffix: "kW",
    },
    {
      id: "F1_Reactive",
      label: "Feeder 1 - Reactive",
      xAxis: "TimeStamp",
      yAxis: "Power",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      suffix: "kVAr",
    },
    {
      id: "F1_Apparent",
      label: "Feeder 1 - Apparent",
      xAxis: "TimeStamp",
      yAxis: "Power",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      suffix: "kVA",
    },
  ],
  insights_config: {
    incomer: [
      {
        id: "incomer_currrent1",
        label: "RMS Current",
        xAxis: "TimeStamp",
        suffix: "A",
        colors: ["#a1c7e2"],
      },
      {
        id: "incomer_currrent2",
        label: "RMS Current",
        xAxis: "TimeStamp",
        suffix: "A",
        colors: ["#e4592c"],
      },
      {
        id: "incomer_currrent3",
        label: "RMS Current",
        xAxis: "TimeStamp",
        suffix: "A",
        colors: ["#1b428b"],
      },
    ],
    feeder: [
      {
        id: "f1_power",
        label: "F1 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
      {
        id: "f2_power",
        label: "F2 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
      {
        id: "f3_power",
        label: "F3 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
      {
        id: "f4_power",
        label: "F4 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
      {
        id: "f5_power",
        label: "F5 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
      {
        id: "f6_power",
        label: "F6 Active Power (kW)",
        xAxis: "TimeStamp",
        suffix: "kW",
        colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      },
    ],
  },
  map_powercoil_legends: [
    {
      label: "No Issues",
      color: "midnightBlue",
    },
    {
      label: "With Issues",
      color: "lightCoral",
    },
  ],
  stats_chart: {
    voltage: [
      [
        {
          id: "L1_RMSVoltage",
          type: "line",
          label: "L1_RMSVoltage",
        },
        {
          id: "L2_RMSVoltage",
          type: "line",
          label: "L2_RMSVoltage",
        },
        {
          id: "L3_RMSVoltage",
          type: "line",
          label: "L3_RMSVoltage",
        },
      ],
    ],
    power: [
      [
        {
          id: "L1_ActivePower",
          type: "line",
          label: "L1_ActivePower",
        },
        {
          id: "L2_ActivePower",
          type: "line",
          label: "L2_ActivePower",
        },
        {
          id: "L3_ActivePower",
          type: "line",
          label: "L3_ActivePower",
        },
      ],
      [
        {
          id: "L1_ReactivePower",
          type: "line",
          label: "L1_ReactivePower",
        },
        {
          id: "L2_ReactivePower",
          type: "line",
          label: "L2_ReactivePower",
        },
        {
          id: "L3_ReactivePower",
          type: "line",
          label: "L3_ReactivePower",
        },
      ],
      [
        {
          id: "L1_ApparentPower",
          type: "line",
          label: "L1_ApparentPower",
        },
        {
          id: "L2_ApparentPower",
          type: "line",
          label: "L2_ApparentPower",
        },
        {
          id: "L3_ApparentPower",
          type: "line",
          label: "L3_ApparentPower",
        },
      ],
    ],
    temprature: [
      [
        {
          id: "TempAmbient",
          type: "line",
          label: "Temp_Ambient",
        },
        {
          id: "TempInternal",
          type: "line",
          label: "Temp_Internal",
        },
      ],
    ],
    ambient_temp: [
      [
        {
          id: "ambient_temp",
          type: "line",
          label: "Ambient Temperature",
        },
      ],
    ],
    boxplot: {
      thd: [
        {
          id: "L1_TotalHarmonicDistortion",
          type: "candle",
          label: "L1",
          values: [
            {
              id: "L1_ThdMax",
              label: "max",
            },
            {
              id: "L1_ThdMeanMax",
              label: "mean_max",
            },
            {
              id: "L1_ThdMeanMin",
              label: "mean_min",
            },
            {
              id: "L1_ThdMin",
              label: "min",
            },
          ],
        },
        {
          id: "L2_TotalHarmonicDistortion",
          type: "candle",
          label: "L2",
          values: [
            {
              id: "L2_ThdMax",
              label: "max",
            },
            {
              id: "L2_ThdMeanMax",
              label: "mean_max",
            },
            {
              id: "L2_ThdMeanMin",
              label: "mean_min",
            },
            {
              id: "L2_ThdMin",
              label: "min",
            },
          ],
        },
        {
          id: "L3_TotalHarmonicDistortion",
          type: "candle",
          label: "L3",
          values: [
            {
              id: "L3_ThdMax",
              label: "max",
            },
            {
              id: "L3_ThdMeanMax",
              label: "mean_max",
            },
            {
              id: "L3_ThdMeanMin",
              label: "mean_min",
            },
            {
              id: "L3_ThdMin",
              label: "min",
            },
          ],
        },
      ],
      voltage: [
        {
          id: "L1_RMSVoltage",
          type: "candle",
          label: "L1",
          values: [
            {
              id: "L1_RMSVMax",
              label: "max",
            },
            {
              id: "L1_RMSVMeanMax",
              label: "mean_max",
            },
            {
              id: "L1_RMSVMeanMin",
              label: "mean_min",
            },
            {
              id: "L1_RMSVMin",
              label: "min",
            },
          ],
        },
        {
          id: "L2_RMSVoltage",
          type: "candle",
          label: "L2",
          values: [
            {
              id: "L2_RMSVMax",
              label: "max",
            },
            {
              id: "L2_RMSVMeanMax",
              label: "mean_max",
            },
            {
              id: "L2_RMSVMeanMin",
              label: "mean_min",
            },
            {
              id: "L2_RMSVMin",
              label: "min",
            },
          ],
        },
        {
          id: "L3_RMSVoltage",
          type: "candle",
          label: "L3",
          values: [
            {
              id: "L3_RMSVMax",
              label: "max",
            },
            {
              id: "L3_RMSVMeanMax",
              label: "mean_max",
            },
            {
              id: "L3_RMSVMeanMin",
              label: "mean_min",
            },
            {
              id: "L3_RMSVMin",
              label: "min",
            },
          ],
        },
      ],
      power: [
        {
          id: "L1_PowerMean",
          type: "candle",
          label: "L1",
          values: [
            {
              id: "L1_PowerMax",
              label: "max",
            },
            {
              id: "L1_PowerMeanMax",
              label: "mean_max",
            },
            {
              id: "L1_PowerMeanMin",
              label: "mean_min",
            },
            {
              id: "L1_PowerMin",
              label: "min",
            },
          ],
        },
        {
          id: "L2_PowerMean",
          type: "candle",
          label: "L2",
          values: [
            {
              id: "L2_PowerMax",
              label: "max",
            },
            {
              id: "L2_PowerMeanMax",
              label: "mean_max",
            },
            {
              id: "L2_PowerMeanMin",
              label: "mean_min",
            },
            {
              id: "L2_PowerMin",
              label: "min",
            },
          ],
        },
        {
          id: "L3_PowerMean",
          type: "candle",
          label: "L3",
          values: [
            {
              id: "L3_PowerMax",
              label: "max",
            },
            {
              id: "L3_PowerMeanMax",
              label: "mean_max",
            },
            {
              id: "L3_PowerMeanMin",
              label: "mean_min",
            },
            {
              id: "L3_PowerMin",
              label: "min",
            },
          ],
        },
      ],
    },
  },

  event_map_config: {
    id: "DeviceID",
    infoText: "TransformerName",
    label: "DeviceID",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "asset",
    type: "HasIssue",
    datatype: "powerdata",
  },
  events_timeline: {
    id: "pq_timeline",
    type: "line",
    label: "PQ Timeline",
    xAxis: "TimeStamp",
    strokeWidth: 3,
    colors: ["#0581c6", "#e14615", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083"],
  },
  event_types: {
    LOSS_OF_MAINS: {
      id: "LOSS_OF_MAINS",
      label: "Loss Of Mains",
      icon: "mdi-power-off",
      textColor: "pink darken-4",
      textColorHEX: "#880E4F",
      backgroundColor: "pink lighten-5",
      backgroundColorHEX: "#FCE4EC",
      svg_path:
        "M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A9,9 0 0,0 21,12A9,9 0 0,0 12,3M12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19Z",
      show: true,
      description: "Loss of grid connection detected when voltage falls below 10% of nominal (no duration reported)",
    },
    INTERRUPT: {
      id: "INTERRUPT",
      label: "Interrupt",
      icon: "mdi-power-plug-off",
      textColor: "indigo darken-3",
      textColorHEX: "#283593",
      backgroundColor: "indigo lighten-5",
      backgroundColorHEX: "#E8EAF6",
      svg_path:
        "M20.84 22.73L15.31 17.2L14.5 18V21H9.5V18L6 14.5V9C6 8.7 6.1 8.41 6.25 8.14L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M18 14.5V9C18 8 17 7 16 7V3H14V7H10.2L17.85 14.65L18 14.5M10 3H8V4.8L10 6.8V3Z",
      show: true,
      description: "Voltage drops to <10% of nominal (>= 10ms)",
    },
    RAPID_VOLTAGE_CHANGE: {
      id: "RAPID_VOLTAGE_CHANGE",
      label: "Variation",
      icon: "mdi-flash-alert",
      textColor: "deep-purple darken-3",
      textColorHEX: "#4527A0",
      backgroundColor: "deep-purple lighten-4",
      backgroundColorHEX: "#D1C4E9",
      svg_path: "M5,2V13H8V22L15,10H11L15,2M17,15H19V17H17V15M17,7H19V13H17V7Z",
      show: true,
      description: "Sudden voltage shift ≥5% from nominal, unrelated to dips/swells",
    },
    DIP: {
      id: "DIP",
      label: "Dip",
      icon: "mdi-trending-down",
      textColor: "red darken-2",
      textColorHEX: "#D32F2F",
      backgroundColor: "red lighten-4",
      backgroundColorHEX: "#FFCDD2",
      svg_path: "m16,18l2.29,-2.29l-4.88,-4.88l-4,4l-7.41,-7.42l1.41,-1.41l6,6l4,-4l6.3,6.29l2.29,-2.29l0,6l-6,0z",
      show: true,
      description: "Voltage decreases below 90% of nominal for 10 ms - 1 min",
    },
    SWELL: {
      id: "SWELL",
      label: "Swell",
      icon: "mdi-trending-up",
      textColor: "blue darken-3",
      textColorHEX: "#1565C0",
      backgroundColor: "blue lighten-4",
      backgroundColorHEX: "#BBDEFB",
      svg_path: "M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z",
      show: true,
      description: "Voltage rises above 110% of nominal for 10 ms - 1 min",
    },
    FLICKER: {
      id: "FLICKER",
      label: "Flicker",
      icon: "mdi-lightbulb-on",
      textColor: "amber darken-3",
      textColorHEX: "#FF8F00",
      backgroundColor: "amber lighten-4",
      backgroundColorHEX: "#FFECB3",
      svg_path:
        "M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z",
      show: true,
      description: "Visible light fluctuations caused by repetitive voltage changes (Pst<1, assessed over 10 minutes)",
    },
    UNKNOWN: {
      id: "UNKNOWN",
      label: "Unknown Event Type",
      icon: "mdi-help",
      textColor: "brown darken-4",
      textColorHEX: "#3E2723",
      backgroundColor: "brown lighten-4",
      backgroundColorHEX: "#D7CCC8",
      svg_path:
        "M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5A3,3 0 0,0 9,8H6A6,6 0 0,1 12,2Z",
      show: false,
      description: "Event type not recognized or not categorized.",
    },
  },
  time_filter: {
    label: "Time Filter",
    value: "timeFilter",
    options: [
      {
        text: i18n.t("common.times.time.last24Hours"),
        value: 1,
      },
      {
        text: i18n.t("common.times.time.last7Days"),
        value: 7,
      },
      {
        text: i18n.t("common.times.time.last28Days"),
        value: 28,
      },
    ],
  },
  events_list: [
    {
      text: "",
      sortable: false,
      of_type: "indicator",
      valueOf: "type",
    },
    {
      align: "start",
      text: "Notification ID",
      value: "startTimestamp",
      sortable: true,
      of_type: "link",
      identifier: ["deviceId", "event_id", "subid", "startTimestamp"],
      url: "/event/",
    },
    {
      text: "Notification Category",
      value: "eventType",
      of_type: "lookup",
      config: "events",
    },
    {
      text: "Sub-category",
      value: "eventType",
      of_type: "lookup",
      config: "events_config",
    },
    {
      text: "Duration",
      value: "duration",
      of_type: "hours",
    },
    {
      text: "Start Time",
      value: "startTimestamp",
      of_type: "epoch",
    },
  ],
  events_table: [
    {
      text: "",
      sortable: false,
      of_type: "indicator",
      valueOf: "eventType",
    },
    {
      text: "Name",
      value: "TransformerName",
      of_type: "link",
      identifier: ["deviceId"],
      url: "/scavenger/",
    },
    {
      text: "Functional Location",
      value: "AssetID",
      of_type: "link",
      identifier: ["deviceId"],
      url: "/scavenger/",
    },
    {
      text: "Event Type",
      value: "eventType",
      of_type: "link",
      config: "events",
      identifier: ["deviceId", "event_id", "subid", "startTimestamp"],
      url: "/event/",
    },
    {
      text: "Duration",
      value: "duration",
      of_type: "hours",
    },
    {
      text: "Start Time",
      value: "startTimestamp",
      of_type: "epoch",
    },
  ],
  events: {
    LOSS_OF_MAINS: "Fault",
    INTERRUPT: "Event",
    RAPID_VOLTAGE_CHANGE: "Event",
    DIP: "Event",
    SWELL: "Event",
    FLICKER: "Event",
  },
  eventPriority: {
    Event: "orange",
    Fault: "vtred",
  },
  insights_chart: [
    [
      {
        id: "F1_L1_RMSCurrentMean",
        type: "line",
        label: "F1 L1 RMS Current",
      },
    ],
    [
      {
        id: "F1_L2_RMSCurrentMean",
        type: "line",
        label: "F1 L2 RMS Current",
      },
    ],
    [
      {
        id: "F1_L3_RMSCurrentMean",
        type: "line",
        label: "F1 L3 RMS Current",
      },
    ],
  ],
  feeder_charts: [
    [
      [
        {
          id: "F1_L1_ActivePowerMean",
          type: "line",
          label: "F1_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F1_L2_ActivePowerMean",
          type: "line",
          label: "F1_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F1_L3_ActivePowerMean",
          type: "line",
          label: "F1_L3_ActivePowerMean",
        },
      ],
    ],
    [
      [
        {
          id: "F2_L1_ActivePowerMean",
          type: "line",
          label: "F2_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F2_L2_ActivePowerMean",
          type: "line",
          label: "F2_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F2_L3_ActivePowerMean",
          type: "line",
          label: "F2_L3_ActivePowerMean",
        },
      ],
    ],
    [
      [
        {
          id: "F3_L1_ActivePowerMean",
          type: "line",
          label: "F3_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F3_L2_ActivePowerMean",
          type: "line",
          label: "F3_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F3_L3_ActivePowerMean",
          type: "line",
          label: "F3_L3_ActivePowerMean",
        },
      ],
    ],
    [
      [
        {
          id: "F4_L1_ActivePowerMean",
          type: "line",
          label: "F4_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F4_L2_ActivePowerMean",
          type: "line",
          label: "F4_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F4_L3_ActivePowerMean",
          type: "line",
          label: "F4_L3_ActivePowerMean",
        },
      ],
    ],
    [
      [
        {
          id: "F5_L1_ActivePowerMean",
          type: "line",
          label: "F5_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F5_L2_ActivePowerMean",
          type: "line",
          label: "F5_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F5_L3_ActivePowerMean",
          type: "line",
          label: "F5_L3_ActivePowerMean",
        },
      ],
    ],
    [
      [
        {
          id: "F6_L1_ActivePowerMean",
          type: "line",
          label: "F6_L1_ActivePowerMean",
        },
      ],
      [
        {
          id: "F6_L2_ActivePowerMean",
          type: "line",
          label: "F6_L2_ActivePowerMean",
        },
      ],
      [
        {
          id: "F6_L3_ActivePowerMean",
          type: "line",
          label: "F6_L3_ActivePowerMean",
        },
      ],
    ],
  ],
  chart_select: [
    {
      id: "day",
      label: "Day",
      value: "1",
      stringValue: "Day",
    },
    {
      id: "week",
      label: "Week",
      value: "7",
      stringValue: "Week",
    },
  ],
  scv_overview: [
    {
      id: "All",
      title: "All",
      icon: "mdi-sitemap",
      backgroundColor: "primary lighten-5",
      textColor: "primary",
      value: i18n.t("views.ScavengerOverview.tabs.all.label"),
      tooltip: "Total number of Devices",
      label: "Installed",
      suffix: ".",
    },
    {
      id: "PQ",
      title: "PQ",
      icon: "mdi-alert-circle-outline",
      backgroundColor: "secondary lighten-5",
      textColor: "secondary",
      value: i18n.t("views.ScavengerOverview.tabs.pq.label"),
      tooltip: "Devices with PQ issues",
      label: "Power Quality",
      suffix: " issues.",
    },
    {
      id: "NZ",
      title: "NZ",
      icon: "mdi-chart-line-variant",
      backgroundColor: "primaryGrey lighten-2",
      textColor: "primaryGrey",
      value: i18n.t("views.ScavengerOverview.tabs.nz.label"),
      tooltip: "Devices with Net Zero capacity planning issues",
      label: "Net Zero",
      suffix: " issues.",
    },
    {
      id: "TH",
      title: "TH",
      icon: "mdi-chart-multiline",
      backgroundColor: "error lighten-5",
      textColor: "error",
      value: i18n.t("views.ScavengerOverview.tabs.th.label"),
      tooltip: "Devices with Transformer health issues",
      label: "Transformer Health",
      suffix: " issues.",
    },
  ],
  scv_h2_overview: [
    {
      id: "All",
      title: "All",
      icon: "mdi-sitemap",
      backgroundColor: "primary lighten-5",
      textColor: "primary",
      value: i18n.t("views.ScavengerOverview.tabs.all.label"),
      tooltip: "Total number of Devices",
      label: "Installed",
      suffix: ".",
    },
    {
      id: "PQ",
      title: "PQ",
      icon: "mdi-alert-circle-outline",
      backgroundColor: "secondary lighten-5",
      textColor: "secondary",
      value: i18n.t("views.ScavengerOverview.tabs.pq.label"),
      tooltip: "Devices with PQ issues",
      label: "Power Quality",
      suffix: " issues.",
    },
    {
      id: "NZ",
      title: "NZ",
      icon: "mdi-chart-line-variant",
      backgroundColor: "primaryGrey lighten-2",
      textColor: "primaryGrey",
      value: i18n.t("views.ScavengerOverview.tabs.nz.label"),
      tooltip: "Devices with Net Zero capacity planning issues",
      label: "Net Zero",
      suffix: " issues.",
    },
    {
      id: "H2",
      title: "H₂",
      icon: "mdi-chart-multiline",
      backgroundColor: "error lighten-5",
      textColor: "error",
      value: i18n.t("views.ScavengerOverview.tabs.h2.label"),
      tooltip: "Devices with H₂ issues",
      label: "Hydrogen(H₂)",
      suffix: " issues.",
      pow: 2,
    },
  ],
  ageing: {
    title: "Ageing",
    tooltip: "Ageing",
    header: [
      "Accelerated Ageing",
      "Normal",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Normal",
        value: "Normal",
        msg: "Normal",
      },
      {
        label: "Accelerated Ageing",
        value: "AcceleratedAgeing",
        msg: "Accelerated Ageing",
      },
      {
        label: "Future Ageing",
        value: "FutureAgeing",
        msg: "Future Ageing",
      },
    ],
  },
  hydrogen: {
    title: "Hydrogen Alerts",
    tooltip: "Hydrogen Alerts",
    header: [
      "Hydrogen Alerts",
      "Normal",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Normal",
        value: "Normal",
        msg: "Normal",
      },
      {
        label: "Hydrogen Alert",
        value: "HydrogenAlert",
        msg: "Hydrogen Alert",
      },
      {
        label: "Hydrogen Rate of Change Alert",
        value: "HydrogenRateOfChangeAlert",
        msg: "Hydrogen Rate of Change Alert",
      },
    ],
  },
  risk_of_overload: {
    title: "Risk of Overload",
    tooltip: "Risk of Overload",
    header: [
      "Risk of Overload",
      "Normal",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Normal",
        value: "Normal",
        msg: "Normal",
      },
      {
        label: "Risk of Overload",
        value: "RiskOfOverload",
        msg: "Risk of Overload",
      },
      {
        label: "Re-Rating Required",
        value: "ReRatingRequired",
        msg: "Re-Rating Required",
      },
    ],
  },
  asset_replacement_maintenance: {
    title: "Asset Replacement/Maintenance",
    tooltip: "Asset Replacement/Maintenance",
    header: [
      "Replacement",
      "Maintenance",
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: "Normal",
        value: "Normal",
        msg: "Normal",
      },
      {
        label: "Replacement",
        value: "Replacement",
        msg: "Replacement",
      },
      {
        label: "Maintenance",
        value: "Maintenance",
        msg: "Maintenance",
      },
      {
        label: "Temperature Issues",
        value: "TemperatureIssues",
        msg: "Temperature Issues",
      },
    ],
  },
  assets_health_table: [
    {
      align: "start",
      text: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
      of_type: "modal",
      sortable: true,
    },
    {
      text: "Asset Name",
      value: "AssetName",
      of_type: "text",
      sortable: true,
    },
    {
      text: "Ageing",
      value: "Ageing",
      of_type: "secondary_icon",
      sortable: true,
    },
    {
      text: "Hydrogen",
      value: "Hydrogen",
      of_type: "secondary_icon",
      sortable: true,
    },
    {
      text: "Risk Of Overload",
      value: "RiskOfOverload",
      of_type: "secondary_icon",
      sortable: true,
    },
    {
      text: "Maintenance",
      value: "AssetReplacementMaintenance",
      of_type: "secondary_icon",
      sortable: true,
    },
    {
      text: "Is Watchlisted",
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
  ],
  device_details_health: [
    {
      label: "Ageing",
      value: "Ageing",
    },
    {
      label: "Hydrogen",
      value: "Hydrogen",
    },
    {
      label: "Risk of Overload",
      value: "RiskOfOverload",
    },
    {
      label: "Maintenance",
      value: "AssetReplacementMaintenance",
    },
  ],
  topology_device_details: [
    {
      label: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
    },
    {
      label: "Transformer Name",
      value: "TransformerName",
    },
    {
      label: "Transformer Number",
      value: "TransformerNo",
    },
    {
      label: "Transformer Rating",
      value: "TransformerRating",
    },
    {
      label: "Device Status",
      value: "DeviceStatus",
    },
    {
      label: "Last Status Update",
      value: "LastStatusUpdate",
    },
  ],
  scavenger_health_charts: [
    {
      id: "ageing",
      label: "Ageing",
      label_daily_stats: "Ageing",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Ageing (Days)",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#a1c7e2", "#1b428b", "#e4592c", "#52a0d2", "#f7af5d"],
      min: 300,
      max: 450,
      nom: 100,
    },
    {
      id: "h2",
      label: "Hydrogen",
      label_daily_stats: "Hydrogen",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Hydrogen",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#52a0d2", "#a1c7e2", "#1b428b", "#e4592c", "#f7af5d"],
      min: 5500,
      max: 6500,
      nom: 4500,
    },
    {
      id: "rate_change",
      label: "Hydrogen Rate of Change",
      label_daily_stats: "Hydrogen Rate of Change",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Hydrogen Rate of Change",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#52a0d2", "#a1c7e2", "#1b428b", "#e4592c", "#f7af5d"],
      min: 10,
      max: 65,
      nom: 30,
    },
  ],
  scavenger_health_table: [
    {
      align: "start",
      text: "ID",
      value: "seqNo",
      of_type: "text",
      sortable: true,
    },
    {
      text: "Name",
      value: "DeviceID",
      of_type: "text",
      sortable: true,
    },
    {
      text: "H₂ Level",
      value: "H2Lvl",
      of_type: "text",
      sortable: true,
    },
    {
      text: "Acceleration Ageing",
      value: "AccelerationAgeing",
      of_type: "text",
      sortable: true,
    },
    {
      text: "Rate of Change",
      value: "RateOfChange",
      of_type: "text",
      sortable: true,
    },
    {
      text: "Date",
      value: "Timestamp",
      of_type: "text",
      sortable: true,
    },
  ],
  health_statictics: [
    {
      label: "Ageing",
      value: "Ageing",
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-clock-outline",
      suffix: "Days",
      type: "lookup",
    },
    {
      label: "Hydrogen",
      value: "Hydrogen",
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-gas-cylinder",
      suffix: "ppm",
      type: "lookup",
    },
    {
      label: "Risk Of Overload",
      value: "RiskOfOverload",
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-trending-up",
      suffix: "ppm/day",
      type: "lookup",
    },
    {
      label: "Temperature",
      value: "AssetReplacementMaintenance",
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-thermometer",
      suffix: "°C",
      type: "lookup",
    },
  ],
  insights_diagram_thd_keys: ["L1_ThdMeanMax", "L2_ThdMeanMax", "L3_ThdMeanMax"],
  lct_chart: [
    {
      id: "EVs",
      label: "Ageing",
      label_daily_stats: "Ageing",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Ageing (Days)",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#a1c7e2", "#1b428b", "#e4592c", "#52a0d2", "#f7af5d"],
      min: 300,
      max: 450,
      nom: 100,
    },
    {
      id: "HVs",
      label: "Hydrogen",
      label_daily_stats: "Hydrogen",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Hydrogen",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#52a0d2", "#a1c7e2", "#1b428b", "#e4592c", "#f7af5d"],
      min: 5500,
      max: 6500,
      nom: 4500,
    },
    {
      id: "PVs",
      label: "Hydrogen Rate of Change",
      label_daily_stats: "Hydrogen Rate of Change",
      seriesType: "lines",
      xAxis: "Date",
      yAxis: "Hydrogen Rate of Change",
      colors: ["#a1c7e2", "#e4592c", "#1b428b", "#52a0d2", "#f7af5d"],
      areaColors: ["#52a0d2", "#a1c7e2", "#1b428b", "#e4592c", "#f7af5d"],
      min: 10,
      max: 65,
      nom: 30,
    },
  ],
};
export { content };
